import React, { useState } from "react";
import Layout from "../Components/Layout";
import {
  Container,
  Row,
  Col,
  FormControl,
  Modal,
  Button,
} from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import LayoutNew from "../Components/LayoutNew";
import {
  accountdelete,
  createStripeAccount,
  logOut,
} from "../Redux/Actions/userActions";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
export default function Settings() {

  
  // // ======================================check for language=======================================

  const ingerman = useSelector((state) => state.homedata.selectedLang);
  console.log(ingerman);


  const navigate = useNavigate();

  const [show, setshow] = useState(false);
  const [showd, setshowd] = useState(false);

  const BankAccount = async () => {
    let data = await createStripeAccount();
    console.log(data, "data");
    if (data?.success) {
      // toast.success(data?.message);
      // sessionStorage.clear();
      // localStorage.clear();
      // setshow(false);
      window.location.href = data?.data?.url;
      // navigate(data?.data?.url);
      // <Link to={data?.data?.url}></Link>
    } else {
      toast.error(data?.message);
    }
  };

  // ================================================get user data from redux===========================================

  const userData = useSelector((state) => state?.registerUserdata?.user);
  console.log(userData);

  return (
    <LayoutNew>
      <div className="right-side">
        <div className="main-content">
          <h2>{ingerman=="de" ? "Einstellungen" : "Settings"}</h2>
          <div className="setting-list-box">
            <ul>
              {userData?.login_type == 2 ? (
                ""
              ) : (
                <li>
                  <Link to="/change-password" className="setting-list-item">
                    <div className="icon-txt">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="63"
                          height="63"
                          viewBox="0 0 63 63"
                          fill="none"
                        >
                          <rect
                            width="62.7451"
                            height="62.7451"
                            rx="31.3725"
                            fill="#4CA890"
                            fill-opacity="0.2"
                          />
                          <path
                            d="M32.2072 28.7639C31.1484 25.7182 28.3056 23.5352 24.9559 23.5352C20.7014 23.5352 17.2554 27.045 17.2554 31.3783C17.2554 35.7116 20.7014 39.2214 24.9559 39.2214C28.3056 39.2214 31.1484 37.0384 32.2072 33.9927H37.7901V39.2214H42.9238V33.9927H45.4907V28.7639H32.2072ZM24.9559 33.9927C23.5377 33.9927 22.3891 32.8227 22.3891 31.3783C22.3891 29.9338 23.5377 28.7639 24.9559 28.7639C26.3741 28.7639 27.5227 29.9338 27.5227 31.3783C27.5227 32.8227 26.3741 33.9927 24.9559 33.9927Z"
                            fill="#4CA890"
                          />
                        </svg>
                      </span>
                      <h3>{ingerman=="de" ? "Passwort ändern" :"Change Password"}</h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </li>
              )}

              <li>
                <Link to="/notification" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M39.7797 27.767C39.7797 29.3431 40.1962 30.272 41.1129 31.3426C41.8076 32.1313 42.0296 33.1436 42.0296 34.2419C42.0296 35.3389 41.6692 36.3804 40.947 37.2259C40.0017 38.2396 38.6684 38.8867 37.3077 38.9992C35.3358 39.1673 33.3629 39.3088 31.3636 39.3088C29.363 39.3088 27.3913 39.2242 25.4194 38.9992C24.0575 38.8867 22.7242 38.2396 21.7801 37.2259C21.058 36.3804 20.6963 35.3389 20.6963 34.2419C20.6963 33.1436 20.9195 32.1313 21.613 31.3426C22.5584 30.272 22.9475 29.3431 22.9475 27.767V27.2324C22.9475 25.1217 23.4738 23.7415 24.5576 22.3904C26.169 20.42 28.7519 19.2383 31.3075 19.2383H31.4197C34.0301 19.2383 36.6965 20.4769 38.2806 22.532C39.3082 23.8553 39.7797 25.1773 39.7797 27.2324V27.767ZM27.6907 41.9028C27.6907 41.271 28.2706 40.9815 28.8069 40.8576C29.4343 40.725 33.257 40.725 33.8843 40.8576C34.4206 40.9815 35.0005 41.271 35.0005 41.9028C34.9693 42.5044 34.6164 43.0379 34.1288 43.3766C33.4964 43.8695 32.7544 44.1816 31.9786 44.2942C31.5496 44.3497 31.128 44.351 30.7139 44.2942C29.9369 44.1816 29.1949 43.8695 28.5637 43.3753C28.0748 43.0379 27.7219 42.5044 27.6907 41.9028Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Benachrichtigung" :"Notification"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M19.1279 31.7869C19.1279 38.7127 24.7499 44.3359 31.6769 44.3359C38.6166 44.3359 44.226 38.7127 44.226 31.7869C44.226 24.8586 38.6166 19.2379 31.6769 19.2379C24.7499 19.2379 19.1279 24.8586 19.1279 31.7869ZM30.5726 36.543C30.5726 37.1441 31.0746 37.6473 31.6769 37.6473C32.2793 37.6473 32.7687 37.1441 32.7687 36.543V30.9963C32.7687 30.3927 32.2793 29.9046 31.6769 29.9046C31.0746 29.9046 30.5726 30.3927 30.5726 30.9963V36.543ZM31.6895 25.9127C31.0746 25.9127 30.5852 26.4147 30.5852 27.017C30.5852 27.6194 31.0746 28.1088 31.6769 28.1088C32.2918 28.1088 32.7813 27.6194 32.7813 27.017C32.7813 26.4147 32.2918 25.9127 31.6895 25.9127Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>FAQs</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/favorite-course" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M44.2145 27.6399C44.271 28.6988 44.1172 29.7731 43.7688 30.7764C42.7582 33.706 40.2879 35.8762 37.915 37.9075C36.3174 39.2751 34.7229 40.6396 33.1253 42.0072C32.6764 42.39 32.1617 42.7974 31.5684 42.7635C31.0725 42.7326 30.6582 42.3992 30.2815 42.0782C28.7687 40.797 27.2589 39.5159 25.746 38.2348C23.9318 36.6943 22.0893 35.1292 20.7679 33.1627C19.2048 30.8351 18.6806 28.208 19.5375 25.5377C20.2563 23.2995 22.2212 21.4658 24.5564 20.9534C27.2055 20.373 30.1623 21.5306 31.6783 23.7472C33.4046 21.154 37.1429 20.0828 40.0149 21.3547C41.7286 22.1141 43.0783 23.6021 43.7343 25.3339C44.0168 26.0717 44.1737 26.8527 44.2145 27.6399Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Lieblingskurs" : "Favorite Course"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li></li>
              <li>
                <Link to="/appointments" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M38.6486 33.1974H31.6769V40.2562H38.6486V33.1974ZM37.2543 17.668V20.4915H26.0996V17.668H23.3109V20.4915H21.9166C20.3759 20.4915 19.1419 21.755 19.1419 23.315L19.1279 43.0797C19.1279 44.6397 20.3759 45.9033 21.9166 45.9033H41.4373C42.978 45.9033 44.226 44.6397 44.226 43.0797V23.315C44.226 21.755 42.978 20.4915 41.4373 20.4915H40.043V17.668H37.2543ZM41.4373 43.0797H21.9166V27.5503H41.4373V43.0797Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Meine Termine" : "My Appointment"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li onClick={BankAccount}>
                <Link to="#" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="40"
                          height="40"
                          rx="20"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M27 17.0693C26.8905 17.3064 26.7034 17.3741 26.4506 17.3741C22.1427 17.3681 17.8349 17.3701 13.529 17.3701C13.1528 17.3701 13.0075 17.2267 13.0075 16.8521C13.0075 16.6289 13.0095 16.4058 13.0075 16.1826C13.0055 15.9714 13.0951 15.8299 13.2921 15.7482C15.466 14.8456 17.6398 13.943 19.8136 13.0364C19.9709 12.9706 20.1122 13.0025 20.2595 13.0643C21.4898 13.5784 22.72 14.0885 23.9503 14.5985C24.8401 14.9672 25.7299 15.3398 26.6218 15.7044C26.789 15.7721 26.9244 15.8618 27 16.0312C27 16.3759 27 16.7226 27 17.0693ZM20.0027 16.1388C20.809 16.1388 21.6132 16.1388 22.4194 16.1388C22.6046 16.1388 22.7479 16.071 22.8315 15.9016C22.9669 15.6227 22.7658 15.3178 22.4413 15.3178C21.6769 15.3158 20.9125 15.3178 20.1481 15.3178C19.2921 15.3178 18.4361 15.3178 17.5821 15.3178C17.4029 15.3178 17.2616 15.3856 17.1799 15.547C17.0366 15.8279 17.2417 16.1368 17.5741 16.1368C18.3823 16.1408 19.1925 16.1388 20.0027 16.1388Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M13.3061 27C13.0692 26.8904 12.9876 26.7031 13.0015 26.4481C13.0154 26.2209 13.0035 25.9918 13.0055 25.7646C13.0075 25.4558 13.2424 25.2207 13.5509 25.2207C16.521 25.2207 19.4911 25.2207 22.4612 25.2207C23.787 25.2207 25.1128 25.2247 26.4386 25.2167C26.7054 25.2147 26.8626 25.3402 26.9721 25.5614C26.9801 25.5773 26.992 25.5893 27 25.6032C27 25.9679 27 26.3325 27 26.6971C26.9343 26.8326 26.8348 26.9323 26.6994 26.998C22.2363 27 17.7712 27 13.3061 27Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M14.3432 18.195C15.024 18.195 15.6929 18.195 16.3717 18.195C16.3717 19.6038 16.3717 21.0105 16.3717 22.4232C15.6989 22.4232 15.026 22.4232 14.3432 22.4232C14.3432 21.0184 14.3432 19.6137 14.3432 18.195Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M23.6338 18.197C24.3146 18.197 24.9874 18.197 25.6682 18.197C25.6682 19.6077 25.6682 21.0145 25.6682 22.4272C24.9874 22.4272 24.3146 22.4272 23.6338 22.4272C23.6338 21.0145 23.6338 19.6077 23.6338 18.197Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M18.7745 22.2498C18.7685 21.949 18.9298 21.7637 19.1567 21.7477C19.3876 21.7318 19.5708 21.9051 19.5927 22.1582C19.6126 22.4032 19.7917 22.5746 20.0167 22.5666C20.2337 22.5587 20.4128 22.3734 20.4108 22.1562C20.4108 21.927 20.2357 21.7577 19.9868 21.7457C19.3936 21.7198 18.9138 21.3273 18.8004 20.7793C18.6789 20.1995 18.9537 19.6496 19.5011 19.3965C19.5966 19.3527 19.5947 19.2909 19.5907 19.2132C19.5807 19.012 19.6544 18.8546 19.8435 18.7709C20.0923 18.6613 20.379 18.8326 20.4088 19.1076C20.4128 19.1475 20.4148 19.1893 20.4108 19.2312C20.3989 19.3188 20.4327 19.3607 20.5183 19.4025C20.9662 19.6217 21.2051 19.9843 21.231 20.4845C21.2429 20.7275 21.0697 20.9148 20.8428 20.9268C20.6139 20.9387 20.4347 20.7674 20.4148 20.5223C20.3929 20.2653 20.2157 20.0939 19.9828 20.1079C19.7718 20.1198 19.5986 20.2991 19.5947 20.5104C19.5907 20.7435 19.7698 20.9168 20.0246 20.9288C20.6139 20.9547 21.0956 21.3512 21.2071 21.9031C21.3246 22.4849 21.0479 23.0269 20.5004 23.2839C20.4387 23.3138 20.4049 23.3437 20.4148 23.4135C20.4208 23.4593 20.4188 23.5051 20.4148 23.5509C20.3989 23.7721 20.2157 23.9435 19.9988 23.9375C19.7877 23.9335 19.5966 23.7622 19.6026 23.547C19.6086 23.3776 19.5489 23.3019 19.4016 23.2222C18.9994 23.005 18.8043 22.6463 18.7745 22.2498Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M13.7978 24.4775C13.7978 24.1726 13.7838 23.8717 13.8018 23.5749C13.8117 23.3955 13.9889 23.2561 14.174 23.2561C14.9623 23.2521 15.7506 23.2521 16.537 23.2561C16.7241 23.258 16.8993 23.3955 16.9092 23.5749C16.9271 23.8737 16.9132 24.1746 16.9132 24.4775C15.8761 24.4775 14.8389 24.4775 13.7978 24.4775Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M23.0903 24.4775C23.0903 24.1726 23.0764 23.8717 23.0943 23.5749C23.1042 23.3955 23.2814 23.2561 23.4665 23.2561C24.2548 23.2521 25.0432 23.2521 25.8295 23.2561C26.0166 23.258 26.1918 23.3955 26.2017 23.5749C26.2197 23.8737 26.2057 24.1746 26.2057 24.4775C25.1686 24.4775 24.1314 24.4775 23.0903 24.4775Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ?"Bankdaten" : "Bank Account"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/change-language" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M26.8579 41.6492H25.744C25.5641 41.6489 25.3915 41.5773 25.2642 41.4501C25.137 41.3228 25.0654 41.1502 25.0651 40.9703V37.0552C25.0651 36.8558 25.006 36.6608 24.8953 36.495C24.7845 36.3292 24.627 36.1999 24.4427 36.1236C24.2585 36.0473 24.0557 36.0273 23.8601 36.0663C23.6646 36.1052 23.4849 36.2013 23.3439 36.3423L20.9657 38.7206C20.8721 38.8142 20.7978 38.9253 20.7472 39.0476C20.6965 39.17 20.6704 39.3011 20.6704 39.4334C20.6704 39.5658 20.6965 39.6969 20.7472 39.8193C20.7978 39.9416 20.8721 40.0527 20.9657 40.1463C21.1548 40.3354 21.4112 40.4416 21.6786 40.4416C21.811 40.4416 21.9421 40.4155 22.0644 40.3649C22.1867 40.3142 22.2978 40.2399 22.3914 40.1463L23.0485 39.4898V40.9703C23.0493 41.6849 23.3335 42.3701 23.8389 42.8755C24.3442 43.3808 25.0294 43.665 25.7441 43.6658H26.8579C27.1254 43.6658 27.3818 43.5596 27.5709 43.3705C27.76 43.1814 27.8662 42.9249 27.8662 42.6575C27.8662 42.3901 27.76 42.1336 27.5709 41.9445C27.3818 41.7554 27.1254 41.6492 26.8579 41.6492Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M36.9414 23.4971H38.0575C38.2369 23.4973 38.4089 23.5687 38.5358 23.6955C38.6627 23.8224 38.734 23.9944 38.7342 24.1738V28.0911C38.7342 28.2905 38.7933 28.4854 38.9041 28.6513C39.0149 28.8171 39.1724 28.9463 39.3566 29.0226C39.5409 29.0989 39.7436 29.1189 39.9392 29.08C40.1348 29.041 40.3144 28.945 40.4554 28.8039L42.8337 26.4257C42.9273 26.3321 43.0015 26.2209 43.0522 26.0986C43.1029 25.9763 43.1289 25.8452 43.1289 25.7128C43.1289 25.5804 43.1029 25.4493 43.0522 25.327C43.0015 25.2047 42.9273 25.0936 42.8337 24.9999C42.74 24.9063 42.6289 24.8321 42.5066 24.7814C42.3843 24.7307 42.2532 24.7047 42.1208 24.7047C41.9884 24.7047 41.8573 24.7307 41.735 24.7814C41.6127 24.8321 41.5015 24.9063 41.4079 24.9999L40.7508 25.6565V24.1738C40.7501 23.4597 40.4661 22.7751 39.9612 22.2701C39.4562 21.7652 38.7716 21.4812 38.0575 21.4805H36.9414C36.674 21.4805 36.4175 21.5867 36.2284 21.7758C36.0393 21.9649 35.9331 22.2214 35.9331 22.4888C35.9331 22.7562 36.0393 23.0127 36.2284 23.2017C36.4175 23.3908 36.674 23.4971 36.9414 23.4971Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M36.9463 38.587C37.2769 38.2435 37.5883 37.8819 37.8789 37.5039H36.0127C36.304 37.8816 36.6157 38.2432 36.9463 38.587Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M43.6658 30.4429H34.59V20.2466C34.59 20.1142 34.564 19.983 34.5133 19.8607C34.4626 19.7384 34.3884 19.6272 34.2947 19.5336C34.2011 19.4399 34.0899 19.3657 33.9676 19.315C33.8453 19.2643 33.7141 19.2383 33.5817 19.2383H20.1362C20.0038 19.2383 19.8727 19.2643 19.7504 19.315C19.628 19.3657 19.5169 19.4399 19.4232 19.5336C19.3296 19.6272 19.2553 19.7384 19.2047 19.8607C19.154 19.983 19.1279 20.1142 19.1279 20.2466V33.6921C19.1279 33.8245 19.154 33.9556 19.2047 34.0779C19.2553 34.2003 19.3296 34.3114 19.4232 34.4051C19.5169 34.4987 19.628 34.573 19.7504 34.6236C19.8727 34.6743 20.0038 34.7004 20.1362 34.7004H29.212V44.8966C29.212 45.0291 29.2381 45.1602 29.2888 45.2825C29.3394 45.4049 29.4137 45.516 29.5073 45.6096C29.601 45.7033 29.7121 45.7776 29.8345 45.8282C29.9568 45.8789 30.0879 45.905 30.2203 45.9049H43.6658C43.7983 45.905 43.9294 45.8789 44.0517 45.8282C44.174 45.7776 44.2852 45.7033 44.3788 45.6096C44.4725 45.516 44.5467 45.4049 44.5974 45.2825C44.6481 45.1602 44.6742 45.0291 44.6741 44.8966V31.4512C44.6742 31.3187 44.6481 31.1876 44.5974 31.0653C44.5467 30.9429 44.4725 30.8318 44.3788 30.7382C44.2852 30.6445 44.174 30.5703 44.0517 30.5196C43.9294 30.4689 43.7983 30.4428 43.6658 30.4429ZM30.5623 29.3197L27.7611 23.7174C27.4187 23.0335 26.2993 23.0335 25.9568 23.7174L23.1557 29.3197C23.0361 29.5589 23.0165 29.8359 23.1011 30.0896C23.1858 30.3434 23.3678 30.5531 23.607 30.6726C23.8463 30.7922 24.1233 30.8118 24.377 30.7272C24.6307 30.6425 24.8404 30.4605 24.96 30.2213L25.2414 29.6583H28.4766L28.758 30.2213C28.8296 30.3625 28.9338 30.4847 29.0619 30.5778C29.1901 30.6708 29.3385 30.7321 29.495 30.7565C29.3143 30.9427 29.2128 31.1917 29.212 31.4512V32.6838H21.1445V21.2549H32.5734V30.4429H30.4051C30.5415 30.2933 30.6295 30.106 30.6575 29.9056C30.6856 29.7051 30.6524 29.5009 30.5623 29.3197ZM27.4684 27.6417H26.2496L26.859 26.4228L27.4684 27.6417ZM40.8647 37.5015H40.3285C39.7931 38.3694 39.1687 39.1791 38.4655 39.9176C39.1461 40.4243 39.889 40.8413 40.6759 41.1583C40.7994 41.2068 40.912 41.2792 41.0074 41.3714C41.1029 41.4635 41.1791 41.5736 41.232 41.6952C41.2848 41.8169 41.313 41.9478 41.3152 42.0804C41.3173 42.213 41.2932 42.3448 41.2443 42.4681C41.1955 42.5914 41.1227 42.7038 41.0303 42.7989C40.9379 42.8941 40.8277 42.9701 40.7058 43.0225C40.584 43.075 40.453 43.1029 40.3204 43.1046C40.1878 43.1064 40.0561 43.0819 39.933 43.0327C38.8587 42.6019 37.8518 42.0192 36.9431 41.3022C36.0344 42.0192 35.0275 42.6019 33.9532 43.0327C33.8352 43.08 33.7093 43.1043 33.5823 43.1044C33.3476 43.1044 33.1203 43.0225 32.9395 42.873C32.7587 42.7235 32.6357 42.5156 32.5916 42.2851C32.5476 42.0547 32.5852 41.8161 32.6981 41.6104C32.8111 41.4047 32.9922 41.2448 33.2102 41.1583C33.9976 40.8416 34.7411 40.4253 35.4226 39.9197C34.7186 39.1806 34.0936 38.3702 33.5576 37.5015H33.0215C32.7541 37.5015 32.4976 37.3953 32.3085 37.2062C32.1194 37.0171 32.0132 36.7606 32.0132 36.4932C32.0132 36.2258 32.1194 35.9693 32.3085 35.7802C32.4976 35.5911 32.7541 35.4849 33.0215 35.4849H35.9348V34.2523C35.9348 33.9849 36.041 33.7284 36.2301 33.5393C36.4192 33.3502 36.6757 33.244 36.9431 33.244C37.2105 33.244 37.467 33.3502 37.6561 33.5393C37.8452 33.7284 37.9514 33.9849 37.9514 34.2523V35.4849H40.8647C41.1321 35.4849 41.3886 35.5911 41.5777 35.7802C41.7668 35.9693 41.873 36.2258 41.873 36.4932C41.873 36.7606 41.7668 37.0171 41.5777 37.2062C41.3886 37.3953 41.1321 37.5015 40.8647 37.5015Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Sprache" : "Language"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <div >
                  <Link to="/terms-and-conditions" className="setting-list-item">
                    <div className="icon-txt">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="63"
                          height="63"
                          viewBox="0 0 63 63"
                          fill="none"
                        >
                          <path
                            d="M38.922 34.0312C36.2834 34.0312 34.1445 36.1702 34.1445 38.8088C34.1445 41.4473 36.2834 43.5863 38.922 43.5863C41.5606 43.5863 43.6995 41.4473 43.6995 38.8088C43.6995 36.1702 41.5606 34.0312 38.922 34.0312ZM39.8127 41.1792C39.8127 41.6709 39.4138 42.0698 38.922 42.0698C38.4303 42.0698 38.0314 41.6709 38.0314 41.1792V38.8294C38.0314 38.3377 38.4303 37.9388 38.922 37.9388C39.4138 37.9388 39.8127 38.3377 39.8127 38.8294V41.1792ZM39.7761 36.923C39.7433 37.1086 39.5745 37.2773 39.3889 37.3102C39.2764 37.3289 39.1227 37.3462 38.9131 37.3467C38.7036 37.3467 38.5503 37.3289 38.4373 37.3102C38.2517 37.2773 38.083 37.1086 38.0502 36.923C38.0314 36.8105 38.0141 36.6567 38.0136 36.4472C38.0136 36.2377 38.0314 36.0844 38.0502 35.9714C38.083 35.7858 38.2517 35.617 38.4373 35.5842C38.5498 35.5655 38.7036 35.5481 38.9131 35.5477C39.1227 35.5477 39.2759 35.5655 39.3889 35.5842C39.5745 35.617 39.7433 35.7858 39.7761 35.9714C39.7948 36.0839 39.8122 36.2377 39.8127 36.4472C39.8127 36.6567 39.7948 36.81 39.7761 36.923Z"
                            fill="#4CA890"
                          />
                          <path
                            d="M32.8317 38.8084C32.8317 37.1819 33.465 35.6523 34.6153 34.502C35.7656 33.3517 37.2947 32.7184 38.9217 32.7184C40.2572 32.7184 41.527 33.1459 42.5756 33.9353C42.6337 33.0859 42.6698 32.1358 42.6712 31.0722C42.6684 28.397 42.4439 26.4381 42.2044 24.9986C41.7853 22.6267 39.6309 20.4723 37.2591 20.0533C35.8195 19.8133 33.8606 19.5887 31.185 19.5859C28.5098 19.5887 26.5505 19.8133 25.1109 20.0528C22.7395 20.4719 20.5852 22.6263 20.1661 24.9981C19.9266 26.4377 19.7025 28.3966 19.6992 31.0717C19.7025 33.7469 19.9266 35.7062 20.1661 37.1458C20.5852 39.5177 22.7395 41.672 25.1114 42.0911C26.5509 42.3306 28.5098 42.5547 31.1855 42.558C32.2491 42.5566 33.1992 42.5205 34.0486 42.4623C33.2592 41.4137 32.8317 40.1444 32.8317 38.8084ZM25.5098 25.1369H36.8606C37.5947 25.1369 38.19 25.7322 38.19 26.4662C38.19 27.2003 37.5947 27.7956 36.8606 27.7956H25.5098C24.7758 27.7956 24.1805 27.2003 24.1805 26.4662C24.1805 25.7322 24.7758 25.1369 25.5098 25.1369ZM25.5098 33.347C24.7758 33.347 24.1805 32.7517 24.1805 32.0177C24.1805 31.2836 24.7758 30.6883 25.5098 30.6883H32.1731C32.9072 30.6883 33.5025 31.2836 33.5025 32.0177C33.5025 32.7517 32.9072 33.347 32.1731 33.347H25.5098Z"
                            fill="#4CA890"
                          />
                          <path
                            d="M0 31.3725C0 14.046 14.046 0 31.3725 0C48.6991 0 62.7451 14.046 62.7451 31.3725C62.7451 48.6991 48.6991 62.7451 31.3725 62.7451C14.046 62.7451 0 48.6991 0 31.3725Z"
                            fill="#4CA890"
                            fill-opacity="0.2"
                          />
                        </svg>
                      </span>
                      <h3>{ingerman=="de" ? "Allgemeine Geschäftsbedingungen" : "General Term and Condition"}</h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </div>
              </li>
              <li>
                <Link to="/data-protection" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        width="63"
                        height="63"
                        viewBox="0 0 63 63"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M28.1 25.1867C32.2974 25.1867 35.7 24.1122 35.7 22.7867C35.7 21.4612 32.2974 20.3867 28.1 20.3867C23.9026 20.3867 20.5 21.4612 20.5 22.7867C20.5 24.1122 23.9026 25.1867 28.1 25.1867Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M20.5 32.3873C20.5 33.5225 23.62 34.7873 28.1 34.7873C29.5827 34.7991 31.0617 34.6392 32.5076 34.3109C32.5273 33.7951 32.7457 33.307 33.117 32.9485C33.4883 32.59 33.9839 32.3889 34.5 32.3873V29.7037C32.9376 30.3873 30.6124 30.7873 28.1 30.7873C25.0872 30.7873 21.9364 30.1729 20.5 29.0117V32.3873Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M20.5 27.5865C20.5 28.7217 23.62 29.9865 28.1 29.9865C30.6744 29.9865 33.1036 29.5361 34.5248 28.8045C34.6251 27.9739 35.047 27.2156 35.7 26.6925V24.2125C34.2636 25.3721 31.1128 25.9865 28.1 25.9865C25.0872 25.9865 21.9364 25.3721 20.5 24.2109V27.5865ZM23.3104 27.4345C23.322 27.3833 23.3437 27.3348 23.3742 27.2919C23.4047 27.2491 23.4434 27.2127 23.488 27.1849C23.5327 27.1572 23.5824 27.1385 23.6343 27.1301C23.6862 27.1216 23.7393 27.1235 23.7904 27.1357C23.9172 27.1649 24.0464 27.1933 24.1784 27.2197C24.2756 27.2395 24.362 27.2946 24.4209 27.3745C24.4797 27.4544 24.5067 27.5532 24.4968 27.6519C24.4868 27.7506 24.4405 27.8421 24.3669 27.9086C24.2933 27.9751 24.1976 28.0118 24.0984 28.0117C24.0715 28.012 24.0447 28.0095 24.0184 28.0041C23.8784 27.9761 23.7411 27.9463 23.6064 27.9145C23.5037 27.8898 23.4149 27.8255 23.3594 27.7356C23.304 27.6456 23.2863 27.5374 23.3104 27.4345ZM21.3376 26.6969C21.3599 26.6493 21.3913 26.6066 21.4301 26.5711C21.4689 26.5357 21.5142 26.5082 21.5637 26.4903C21.6131 26.4724 21.6655 26.4644 21.718 26.4668C21.7705 26.4692 21.822 26.4818 21.8696 26.5041C21.9896 26.5604 22.1153 26.6145 22.2468 26.6665C22.2967 26.6851 22.3424 26.7134 22.3812 26.7498C22.42 26.7862 22.4512 26.8299 22.4728 26.8785C22.4945 26.9271 22.5063 26.9796 22.5074 27.0328C22.5086 27.086 22.4992 27.1388 22.4796 27.1883C22.4601 27.2378 22.4309 27.2829 22.3937 27.321C22.3565 27.3591 22.3121 27.3893 22.2631 27.41C22.2141 27.4307 22.1614 27.4414 22.1082 27.4415C22.055 27.4416 22.0023 27.4311 21.9532 27.4105C21.806 27.3521 21.6644 27.2905 21.5304 27.2289C21.4828 27.2067 21.44 27.1753 21.4046 27.1365C21.3691 27.0977 21.3417 27.0523 21.3238 27.0029C21.3059 26.9535 21.2979 26.901 21.3002 26.8485C21.3026 26.796 21.3153 26.7445 21.3376 26.6969ZM35.3 32.3865H36.1V29.1865C36.1 28.7622 36.2686 28.3552 36.5686 28.0552C36.8687 27.7551 37.2757 27.5865 37.7 27.5865H38.5C38.9243 27.5865 39.3313 27.7551 39.6314 28.0552C39.9314 28.3552 40.1 28.7622 40.1 29.1865V32.3865H40.9V29.1865C40.8994 28.5502 40.6463 27.9401 40.1964 27.4902C39.7464 27.0402 39.1363 26.7872 38.5 26.7865H37.7C37.0637 26.7872 36.4536 27.0402 36.0036 27.4902C35.5537 27.9401 35.3006 28.5502 35.3 29.1865V32.3865ZM38.1 35.9865C37.8365 35.9873 37.5806 36.0748 37.3717 36.2355C37.1629 36.3962 37.0127 36.6212 36.9445 36.8757C36.8762 37.1302 36.8936 37.4001 36.994 37.6438C37.0944 37.8874 37.2722 38.0912 37.5 38.2237C37.5609 38.2589 37.6114 38.3094 37.6465 38.3703C37.6816 38.4312 37.7001 38.5003 37.7 38.5705V39.5865H38.5V38.5705C38.4999 38.5003 38.5184 38.4312 38.5535 38.3703C38.5886 38.3094 38.6391 38.2589 38.7 38.2237C38.9278 38.0912 39.1056 37.8874 39.206 37.6438C39.3064 37.4001 39.3238 37.1302 39.2555 36.8757C39.1873 36.6212 39.0371 36.3962 38.8283 36.2355C38.6195 36.0748 38.3635 35.9873 38.1 35.9865ZM28.1 39.5865C29.5801 39.5986 31.0566 39.4393 32.5 39.1117V35.1349C31.0541 35.4451 29.5787 35.5966 28.1 35.5865C25.0872 35.5865 21.9364 34.9721 20.5 33.8109V37.1865C20.5 38.3217 23.62 39.5865 28.1 39.5865Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M42.9008 34.3875C42.9008 34.0692 42.7744 33.764 42.5493 33.539C42.3243 33.3139 42.019 33.1875 41.7008 33.1875H34.5008C34.1825 33.1875 33.8773 33.3139 33.6523 33.539C33.4272 33.764 33.3008 34.0692 33.3008 34.3875V41.5875C33.3008 41.9058 33.4272 42.211 33.6523 42.436C33.8773 42.6611 34.1825 42.7875 34.5008 42.7875H41.7008C42.019 42.7875 42.3243 42.6611 42.5493 42.436C42.7744 42.211 42.9008 41.9058 42.9008 41.5875V34.3875ZM39.3008 38.7875V39.5875C39.3008 39.7997 39.2165 40.0032 39.0665 40.1532C38.9164 40.3032 38.713 40.3875 38.5008 40.3875H37.7008C37.4886 40.3875 37.2851 40.3032 37.1351 40.1532C36.9851 40.0032 36.9008 39.7997 36.9008 39.5875V38.7875C36.565 38.5356 36.3169 38.1845 36.1918 37.7838C36.0666 37.3832 36.0707 36.9533 36.2034 36.555C36.3362 36.1568 36.5908 35.8105 36.9314 35.565C37.2719 35.3196 37.681 35.1875 38.1008 35.1875C38.5205 35.1875 38.9297 35.3196 39.2702 35.565C39.6107 35.8105 39.8654 36.1568 39.9981 36.555C40.1309 36.9533 40.135 37.3832 40.0098 37.7838C39.8846 38.1845 39.6366 38.5356 39.3008 38.7875Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Datenschutz" : "Data Protection"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>

              <li>
                <div >
                <Link to="/invoice-price" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M37.6164 20.8047H26.5901C25.859 20.8047 25.1578 21.0951 24.6409 21.6121C24.1239 22.129 23.8335 22.8302 23.8335 23.5613V42.7655L27.2057 40.4591L29.66 42.137L32.1097 40.4591L34.5594 42.137L37.0072 40.4601L40.373 42.7655V23.5613C40.373 22.8302 40.0826 22.129 39.5656 21.6121C39.0487 21.0951 38.3475 20.8047 37.6164 20.8047ZM34.8598 33.6687H27.5089V31.831H34.8598V33.6687ZM36.6976 29.0744H27.5089V27.2367H36.6976V29.0744Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Rechnungen" : "Invoice"}</h3>
                  </div>
                 
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </div>
              </li>

              <li>
                <Link to="/imprint" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M33.4787 38.8438L32.5079 40.6623C32.4388 40.7927 32.2987 40.875 32.1464 40.875C31.9941 40.875 31.855 40.7927 31.7849 40.6623L30.8162 38.8447C25.1267 39.0153 22.2651 40.179 22.2651 40.7966C22.2651 41.4848 25.6588 42.768 32.1474 42.768C38.636 42.768 42.0297 41.4848 42.0297 40.7966C42.0297 40.179 39.1681 39.0163 33.4778 38.8447L33.4787 38.8438Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M30.0356 36.1303C30.1879 36.1303 30.327 36.2127 30.3971 36.3431L31.4227 38.2675C31.4257 38.2733 31.4288 38.2773 31.4308 38.2831L32.1456 39.6232L32.8625 38.2802C32.8646 38.2763 32.8666 38.2723 32.8686 38.2674L33.8962 36.3421C33.9653 36.2117 34.1054 36.1293 34.2577 36.1293H37.9428C39.1227 36.1293 40.0813 35.2029 40.0813 34.0647V22.8732C40.0813 21.7321 39.1217 20.8047 37.9428 20.8047H26.3506C25.1686 20.8047 24.208 21.7331 24.208 22.8732V34.0647C24.208 35.2039 25.1696 36.1293 26.3506 36.1293H30.0356L30.0356 36.1303ZM30.5322 28.4701C29.8782 27.9956 29.4538 27.2427 29.4538 26.3938C29.4538 24.9605 30.6621 23.794 32.1466 23.794C33.6311 23.794 34.8394 24.9606 34.8394 26.3938C34.8394 27.2427 34.414 27.9947 33.761 28.4701C35.5807 29.0613 36.9363 30.6249 37.1313 32.5659C37.1536 32.7815 36.9891 32.9737 36.7668 32.9943C36.7536 32.9952 36.7404 32.9962 36.7272 32.9962C36.52 32.9962 36.3433 32.8453 36.323 32.6423C36.1138 30.564 34.3186 28.9965 32.1477 28.9965C29.9767 28.9965 28.1814 30.5641 27.9724 32.6423C27.95 32.858 27.7531 33.0168 27.5287 32.9942C27.3053 32.9737 27.1418 32.7815 27.1641 32.5658C27.3601 30.6248 28.7147 29.0621 30.5344 28.4701L30.5322 28.4701Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M32.1496 28.2093C33.1864 28.2093 34.0302 27.3946 34.0302 26.3937C34.0302 25.3928 33.1864 24.5781 32.1496 24.5781C31.1129 24.5781 30.269 25.3928 30.269 26.3937C30.269 27.3946 31.1129 28.2093 32.1496 28.2093Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Impressum" : "Imprint"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/delete-user-account" className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M23.9899 26.2872C23.2823 26.2872 22.6148 26.2897 21.9465 26.2856C21.7934 26.2848 21.6345 26.2831 21.4879 26.2438C20.9563 26.0997 20.6419 25.6066 20.7041 25.0423C20.7606 24.5313 21.2004 24.1292 21.7344 24.1029C21.8204 24.0989 21.9056 24.0997 21.9916 24.0997C28.4518 24.0997 34.9129 24.0989 41.3731 24.1021C41.5509 24.1021 41.7376 24.1087 41.9055 24.1595C42.4239 24.3183 42.7171 24.813 42.6442 25.365C42.5779 25.8646 42.143 26.2684 41.6197 26.2807C40.9849 26.2954 40.3502 26.2864 39.7147 26.2872C39.6123 26.2872 39.5099 26.2872 39.36 26.2872C39.36 26.4092 39.36 26.5165 39.36 26.623C39.36 30.8695 39.3584 35.1152 39.3609 39.3617C39.3617 40.6868 38.7941 41.6852 37.6557 42.3551C37.1332 42.6631 36.5566 42.7671 35.9522 42.7655C33.7212 42.7597 31.4903 42.763 29.2602 42.763C28.6336 42.763 28.0071 42.7646 27.3814 42.763C25.4068 42.7564 23.9916 41.3461 23.9899 39.3732C23.9866 35.1357 23.9891 30.8982 23.9891 26.6599C23.9899 26.5493 23.9899 26.4387 23.9899 26.2872ZM30.5812 33.4412C30.5812 32.849 30.5837 32.2577 30.5804 31.6656C30.5779 31.2798 30.5968 30.8908 30.5509 30.51C30.4829 29.9506 29.9735 29.5534 29.4313 29.5853C28.8507 29.6197 28.3871 30.0734 28.3847 30.6533C28.3765 32.5059 28.3789 34.3584 28.3838 36.211C28.3847 36.546 28.5313 36.8269 28.7974 37.0316C29.1553 37.3077 29.5501 37.3568 29.9571 37.1586C30.3855 36.9497 30.5787 36.5837 30.5804 36.116C30.5837 35.2249 30.5804 34.3331 30.5812 33.4412ZM34.971 33.4567C34.971 32.5558 34.9833 31.6549 34.962 30.7549C34.9563 30.5264 34.8875 30.2757 34.7737 30.0775C34.5345 29.6631 34.0243 29.4977 33.5615 29.6295C33.0873 29.7655 32.772 30.1938 32.7712 30.7401C32.7671 32.5329 32.7679 34.3257 32.7728 36.1176C32.7728 36.261 32.7982 36.41 32.8449 36.5452C33.0128 37.0366 33.519 37.3388 34.0185 37.2601C34.5746 37.1733 34.9628 36.7442 34.9678 36.1823C34.9759 35.2757 34.9702 34.3658 34.971 33.4567Z"
                          fill="#4CA890"
                        />
                        <path
                          d="M31.6631 22.9891C30.917 22.9891 30.1717 22.9998 29.4256 22.9858C28.8851 22.976 28.4494 22.5575 28.3855 22.0276C28.3216 21.5002 28.6541 20.9973 29.1709 20.8474C29.252 20.8237 29.3388 20.8098 29.4231 20.8089C30.9235 20.8065 32.4231 20.7999 33.9235 20.8106C34.4641 20.8147 34.899 21.2365 34.9637 21.768C35.0284 22.2946 34.6967 22.8016 34.1774 22.9457C34.0398 22.9842 33.89 22.9883 33.7458 22.9899C33.0513 22.994 32.3568 22.9916 31.6631 22.9916C31.6631 22.9916 31.6631 22.9899 31.6631 22.9891Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Konto löschen":"Delete Account"}</h3>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                  >
                    <path
                      d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                      fill="#585858"
                    />
                  </svg>
                </Link>
              </li>

              <li style={{cursor:"pointer"}} onClick={() => navigate("/logout-page")}>
                <div className="setting-list-item">
                  <div className="icon-txt">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                      >
                        <rect
                          x="0.304199"
                          y="0.414062"
                          width="62.7451"
                          height="62.7451"
                          rx="31.3725"
                          fill="#4CA890"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M34.5821 20.8047C37.3931 20.8047 39.6857 22.9898 39.6857 25.68V30.9396H32.7734C32.278 30.9396 31.8863 31.3129 31.8863 31.7851C31.8863 32.2463 32.278 32.6306 32.7734 32.6306H39.6857V37.8792C39.6857 40.5694 37.3931 42.7655 34.5591 42.7655H28.9486C26.1261 42.7655 23.8335 40.5804 23.8335 37.8902V25.691C23.8335 22.9898 26.1376 20.8047 28.9601 20.8047H34.5821ZM42.562 27.9971C42.9016 27.6567 43.4565 27.6567 43.7962 27.9861L47.1025 31.1814C47.2723 31.3461 47.3629 31.5547 47.3629 31.7853C47.3629 32.0049 47.2723 32.2245 47.1025 32.3782L43.7962 35.5735C43.6263 35.7382 43.3999 35.8261 43.1847 35.8261C42.9583 35.8261 42.7318 35.7382 42.562 35.5735C42.2223 35.2441 42.2223 34.7061 42.562 34.3767L44.3736 32.6308H39.6859V30.9398H44.3736L42.562 29.1939C42.2223 28.8645 42.2223 28.3265 42.562 27.9971Z"
                          fill="#4CA890"
                        />
                      </svg>
                    </span>
                    <h3>{ingerman=="de" ? "Ausloggen" : "Log out"}</h3>
                  </div>
                  <Link to="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="16"
                      viewBox="0 0 11 16"
                      fill="none"
                    >
                      <path
                        d="M7.01211 7.84314L0.911621 1.74265L2.65427 0L10.4974 7.84314L2.65427 15.6863L0.911621 13.9436L7.01211 7.84314Z"
                        fill="#585858"
                      />
                    </svg>
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </LayoutNew>
  );
}
